import React, { useState , useEffect } from "react";
import "../../styles/owner/HomeOwner.css";
import AdminsSection from "./AdminsSection";
import PlansSection from "./PlansSection";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../BaseUrl";
import axios from "axios";
import PendingAdminsSection from "./PendingAdminsSection";
import BestTeachersSection from "./BestTeachersSection";
import WatingAdminsSection from "./WatingAdminsSection";
export default function HomeOwner() {

    const navigate = useNavigate();
    const handleLogout = () => {
        axios.get(`${BASE_URL}/owner/logout`, { withCredentials: true })
            .then(() => {
                navigate("/");
            })
            .catch((error) => {
                console.error("Logout failed:", error);
                navigate("/");
            });
    } 

    const [message, setMessage] = useState("error message");
    const [updatePasswordForm, setUpdatePasswordForm] = useState({
        oldPassword: "",
        newPassword: "",
        confirmationPassword: ""
    });
    const [showIncreaseYearsConfirmation, setShowIncreaseYearsConfirmation] = useState(false);
    const [showUpdatePasswordForm, setShowUpdatePasswordForm] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [reloadAdmins, setReloadAdmins] = useState(false);
    const [reloadBestTeachers, setReloadBestTeachers] = useState(false);
    const [reloadVersion, setReloadVersion] = useState(false);
    const [bestTeachers, setBestTeachers] = useState([]);
    const [showUpdateVersionForm, setShowUpdateVersionForm] = useState(false);
    const [versions, setVersions] = useState([]);
    const [newVersion, setNewVersion] = useState({});
    const [multiDevices, setMultiDevices] = useState(false);


    const deleteVersion = (version, build) => {
        axios.delete(`${BASE_URL}/owner/delete-version?version=${version}&build=${build}`, { withCredentials: true })
            .then((response) => {
                setReloadVersion(!reloadVersion);
            }).catch((error) => {
                console.error("Failed to delete version:", error);
            });
    };
    const addNewVersion = () => {
        axios.post(`${BASE_URL}/owner/add-version`, newVersion, { withCredentials: true })
            .then((response) => {
                setMessage("تم اضافة الاصدار بنجاح");
                setShowUpdateVersionForm(false);
                setNewVersion({});
                setShowMessage(true);
                setReloadVersion(!reloadVersion);
            })
            .catch((error) => {
                console.error("Failed to add new version:", error);
            });
    };

    const UpdatePassword = ()=>{
        if(updatePasswordForm.newPassword !== updatePasswordForm.confirmationPassword){
            setShowUpdatePasswordForm(false);
            setUpdatePasswordForm({ oldPassword: "", newPassword: "", confirmationPassword: "" });
            setMessage("كلمة المرور الجديدة وتأكيد كلمة المرور غير متطابقين");
            setShowMessage(true);
            return;
        }
        if(updatePasswordForm.oldPassword === updatePasswordForm.newPassword){
            setShowUpdatePasswordForm(false);
            setUpdatePasswordForm({ oldPassword: "", newPassword: "", confirmationPassword: "" });
            setMessage("كلمة المرور الجديدة يجب أن تكون مختلفة عن كلمة المرور القديمة");
            setShowMessage(true);
            return;
        }
        axios.put(`${BASE_URL}/owner/update-password`, updatePasswordForm, { withCredentials: true })
        .then((response)=>{
            setShowUpdatePasswordForm(false);
            setUpdatePasswordForm({ oldPassword: "", newPassword: "", confirmationPassword: "" });
            setMessage(response.data);
            setShowMessage(true);
            setUpdatePasswordForm({ oldPassword: "", newPassword: "", confirmationPassword: "" });
        })
        .catch((error) => {
            setShowUpdatePasswordForm(false);
            setUpdatePasswordForm({ oldPassword: "", newPassword: "", confirmationPassword: "" });
            setMessage(error.response.data || "An error occurred while updating the password.");
            console.log(error);
            setShowMessage(true);
        });
    }

    function increaseYears(){
        axios.get(`${BASE_URL}/owner/increase-years`, { withCredentials: true })
        .then((response)=>{
            setMessage(response.data);
            setShowIncreaseYearsConfirmation(false);
            setShowMessage(true);
        })
        .catch((error) => {
            setMessage(error.response.data || "An error occurred while increasing the years.");
            console.log(error);
            setShowIncreaseYearsConfirmation(false);
            setShowMessage(true);
        });
    }

    useEffect(() => {
        axios.get(`${BASE_URL}/owner/get-all-versions`, { withCredentials: true })
            .then((response) => {
                setVersions(response.data);
            })
            .catch((error) => {
                console.error("Failed to fetch version:", error);
                navigate("/");
            });
        axios.get(`${BASE_URL}/owner/multi-devices`, { withCredentials: true })
            .then((response) => {
                setMultiDevices(response.data);
            })
            .catch((error) => {
                console.log(error);
                navigate("/");
            });

    }, [reloadVersion]);

    const toggelMultiDevices = () =>{
        axios.put(`${BASE_URL}/owner/multi-device?value=${!multiDevices}`, {}, { withCredentials: true })
            .then((response) => {
                setMultiDevices(!multiDevices);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <div className="home-owner-container">
            <h1>لوحة التحكم لمنصة تفوَّق</h1>
            <div className="home-owner-buttons-div">
                <button className="update-version-button" onClick={()=>{
                    navigate("/owner/statistics");
                }} >الإحصائيات</button>
                <button className="update-version-button" onClick={()=>setShowUpdatePasswordForm(true)}>
                    تغيير كلمة المرور
                </button>
                <label className="toggle-container">
                    <span className="toggle-label">أجهزة متعددة</span>

                    <input
                        type="checkbox"
                        checked={multiDevices}
                        onChange={toggelMultiDevices}
                    />

                    <span className="toggle-switch"></span>
                </label>
                <span class="slider"></span>
                <button className= "update-version-button" onClick={()=>setShowIncreaseYearsConfirmation(true)} >زيادة الفصل الدراسي</button>
            {/* </label> */}
            <button className="update-version-button" onClick={() => setShowUpdateVersionForm(true)}>
                تحديث اصدار التطبيق
            </button>
            <button className="update-version-button" onClick={() => navigate("/owner/polls")}>
                إدارة الاستطلاعات
            </button>
            </div>
            <button  className="logout-button"
                onClick={handleLogout}>
              <FiLogOut size={32} color="red" />
            </button>
                
            {showUpdateVersionForm && (
                <div className="overlay">
                    <div className="edit-admin-form">
                        <h2 style={{width: "100%"}}>تحديث اصدار التطبيق</h2>
                        <label>الإصدارات</label>
                        <table>
                            <thead>
                                <tr>
                                    <th>الإصدار</th>
                                    <th>البناء</th>
                                    <th>حذف</th>
                                </tr>
                            </thead>
                            <tbody>
                                {versions.map((version, index) => (
                                    <tr key={index}>
                                        <td>{version.latest_version}</td>
                                        <td>{version.build_number}</td>
                                        <td>
                                            <button
                                                onClick={() => {deleteVersion(version.latest_version, version.build_number)}}
                                            >
                                                حذف
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <label>الإصدار</label>
                        <input
                            type="text"
                            placeholder="إصدار جديد"
                            onChange={(e) => setNewVersion({ ...newVersion, version: e.target.value })}
                        />
                        <label>البناء</label>
                        <input
                            type="text"
                            placeholder="بناء جديد"
                            onChange={(e) => setNewVersion({ ...newVersion, build: e.target.value })}
                        />
                        <div className="edit-admin-buttons">
                            <button onClick={addNewVersion}>إضافة</button>
                        <button onClick={() => {
                            setShowUpdateVersionForm(false);
                            setNewVersion({version: "", build: ""});
                            }}>إلغاء</button>
                        </div>
                    </div>
                </div>
            )}

            <WatingAdminsSection message={message} setMessage={setMessage} showMessage={showMessage} setShowMessage={setShowMessage} reloadAdmins={reloadAdmins} setReloadAdmins={setReloadAdmins}/>
            <AdminsSection message={message} setMessage={setMessage} showMessage={showMessage} setShowMessage={setShowMessage} reloadAdmins={reloadAdmins} bestTeachers={bestTeachers} setBestTeachers={setBestTeachers} />
            { showMessage && (
                <div className="overlay">
                    <div className="home-owner-message">
                        <p>{message}</p>
                        <button onClick={() => setShowMessage(false)}>Close</button>
                    </div>
                </div>
            )}

            {showUpdatePasswordForm && (
                <div className="overlay">
                    <div className="edit-admin-form">
                        <h2 style={{width: "100%"}}>تغيير كلمة المرور</h2>
                        <label>كلمة المرور القديمة</label>
                        <input
                            type="password"
                            placeholder="كلمة المرور القديمة"
                            value={updatePasswordForm.oldPassword || ""}
                            onChange={(e) => setUpdatePasswordForm({ ...updatePasswordForm, oldPassword: e.target.value })}
                        />
                        <label>كلمة المرور الجديدة</label>
                        <input
                            type="password"
                            placeholder="كلمة المرور الجديدة"
                            value={updatePasswordForm.newPassword || ""}
                            onChange={(e) => setUpdatePasswordForm({ ...updatePasswordForm, newPassword: e.target.value })}
                        />
                        <label>تأكيد كلمة المرور الجديدة</label>
                        <input
                            type="password"
                            placeholder="تأكيد كلمة المرور الجديدة"
                            value={updatePasswordForm.confirmationPassword || ""}
                            onChange={(e) => setUpdatePasswordForm({ ...updatePasswordForm, confirmationPassword: e.target.value })}
                        />
                        <div className="edit-admin-buttons">
                            <button onClick={UpdatePassword}>تحديث</button>
                            <button onClick={() => {
                                setShowUpdatePasswordForm(false);
                                setUpdatePasswordForm({ oldPassword: "", newPassword: "", confirmationPassword: "" });
                            }}>إلغاء</button>
                        </div>
                    </div>
                </div>
            )}

            {showIncreaseYearsConfirmation && (
                <div className="overlay">
                    <div className="home-owner-message">
                        <p>هل أنت متأكد من رغبتك في زيادة سنوات الدراسة؟</p>
                        <div className="increase-years-buttons">
                            <button onClick={increaseYears}>تأكيد</button>
                            <button onClick={() => setShowIncreaseYearsConfirmation(false)}>إلغاء</button>
                        </div>
                    </div>
                </div>
            )}
            <PendingAdminsSection message={message} setMessage={setMessage} showMessage={showMessage} setShowMessage={setShowMessage} reloadAdmins={reloadAdmins} setReloadAdmins={setReloadAdmins}/>
            <BestTeachersSection message={message} setMessage={setMessage} showMessage={showMessage} setShowMessage={setShowMessage} bestTeachers={bestTeachers} setBestTeachers={setBestTeachers} />
            <PlansSection setMessage={setMessage} setShowMessage={setShowMessage} />
        </div>
    );
}   